import type { DropDownListViewModel } from '@/shared/api/generated/types/DropDownListViewModel';

import type { TutorFilterOption } from '../types/tutorAi';

/**
 * Converte a resposta dos lookups compartilhados em opções de filtro.
 *
 * Os lookups devolvem `DropDownListViewModel` (`key` numérico, `value` textual) com todos
 * os campos opcionais. Itens sem `key` são descartados: sem identificador não há como
 * filtrar por eles, e deixá-los na lista produziria uma opção que não faz nada ao ser
 * selecionada.
 *
 * @param data - Resposta do lookup, possivelmente ausente durante o carregamento
 * @returns Opções prontas para o componente de seleção
 *
 * @example
 * ```ts
 * mapLookupOptions([{ key: 101, value: 'MBA em Agronegócio' }]);
 * // [{ value: '101', label: 'MBA em Agronegócio' }]
 * ```
 */
export function mapLookupOptions(
  data: readonly DropDownListViewModel[] | undefined,
): TutorFilterOption[] {
  if (!data) return [];

  return data.reduce<TutorFilterOption[]>((options, item) => {
    if (item.key === undefined || item.key === null) return options;

    options.push({ value: String(item.key), label: item.value ?? '' });
    return options;
  }, []);
}
